import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SpecialsBanner from "./components/SpecialsBanner";
import Home from "./pages/Home";
import BookPage from "./pages/BookPage";
import ManageBooking from "./pages/ManageBooking";
import ServiceDetail from "./pages/ServiceDetail";
import FormPage from "./pages/FormPage";
import GiftPage from "./pages/GiftPage";
import GiftCertificate from "./pages/GiftCertificate";
import PortalLogin from "./pages/PortalLogin";
import PortalDashboard from "./pages/PortalDashboard";
import AdminLogin from "./pages/AdminLogin";
import ResetPassword from "./pages/ResetPassword";
import AdminDashboard from "./pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Layout() {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/admin") || pathname.startsWith("/forms") || /^\/gift\/[^/]+$/.test(pathname);
  return (
    <div className="min-h-screen bg-ivory">
      {!bare && <SpecialsBanner />}
      {!bare && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/book" element={<BookPage />} />
        <Route path="/manage/:bookingId" element={<ManageBooking />} />
        <Route path="/services/:serviceId" element={<ServiceDetail />} />
        <Route path="/forms/:formType" element={<FormPage />} />
        <Route path="/gift" element={<GiftPage />} />
        <Route path="/gift/:giftId" element={<GiftCertificate />} />
        <Route path="/portal/login" element={<PortalLogin />} />
        <Route path="/portal" element={<PortalDashboard />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
      {!bare && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Layout />
        <Toaster position="bottom-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
